module.exports = __webpack_public_path__ + "img/Pirate_Staff.9b36b7db.gif";